import { useState, useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { MatchedOffersCountState, ReadOffersCountState } from "@/view_models/atoms";

// 累計既読/マッチング件数を取得し、Recoilに保存する
export const useGetUserTotalReadAndMatchCount = (): boolean => {
  const [loadingCounts, setLoadingCounts] = useState(true);
  const setReadCounts = useSetRecoilState(ReadOffersCountState);
  const setMatchCounts = useSetRecoilState(MatchedOffersCountState);

  useEffect(() => {
    const fetchInvestmentProposals = async () => {
      const fp = PropallyApiFactory();
      try {
        const data = await fp.v1UserTotalReadAndMatchCountGet({ withCredentials: true });
        if (data.status === 200) {
          setReadCounts(data.data.read_offers_count);
          setMatchCounts(data.data.matched_offers_count);
          setLoadingCounts(false);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchInvestmentProposals();
  }, []);

  return loadingCounts;
};
